import $ from 'jquery';

function create(prototype) {
  function F() {}
  F.prototype = prototype;
  return new F();
}

function inherit(subclass, superclass, newProto) {
  const proto = create(superclass.prototype);
  subclass.prototype = $.extend(proto, newProto);
  subclass.prototype.constructor = subclass;
}

export default inherit;


/** WEBPACK FOOTER **
 ** ./src/IIM/core/utils/inherit.js
 **/